export enum WidgetConfigPages {
  HomePage = 'homePage',
  TextChatbotsPage = 'textChatbotsPage',
  VideoBotPage = 'videoBotPage',
  AIBotPage = 'aiBotPage',
  HumanClone = 'humanClone',
  BusinessPartner = 'businessPartner',
  ROICalculator = 'roiCalculator',
  DiscoverChatbotType = 'discoverChatbotType',
  DiscoverHumanCloneLink = 'discoverHumanCloneLink',
  RevenueCalculator = 'revenueCalculator',
  DiscoverChatbotText = 'discoverChatbotText',
  DiscoverChatbotAI = 'discoverChatbotAI',
  DiscoverVideobot = 'discoverVideobot',
  DiscoverCallBot = 'discoverCallbot',
}

type Languages = 'en-US' | 'fr-FR';

type ConfigMap = Record<Languages, string>;

type Configs = Record<WidgetConfigPages, ConfigMap>;

const configs: Configs = {
  [WidgetConfigPages.HomePage]: {
    'en-US': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
    'fr-FR': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
  },
  [WidgetConfigPages.TextChatbotsPage]: {
    'en-US': '8f00af48-bd83-4936-9f57-993ab3f8c7c0',
    'fr-FR': 'c48272ec-f75e-415d-9782-1aaf69532a87',
  },
  [WidgetConfigPages.VideoBotPage]: {
    'en-US': '5f44146f-be02-4ef3-9f8b-5fec94a2f00f',
    'fr-FR': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
  },
  [WidgetConfigPages.AIBotPage]: {
    'en-US': '5f44146f-be02-4ef3-9f8b-5fec94a2f00f',
    'fr-FR': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
  },
  [WidgetConfigPages.HumanClone]: {
    'en-US': '5f44146f-be02-4ef3-9f8b-5fec94a2f00f',
    'fr-FR': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
  },
  [WidgetConfigPages.BusinessPartner]: {
    'en-US': '5f44146f-be02-4ef3-9f8b-5fec94a2f00f',
    'fr-FR': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
  },
  [WidgetConfigPages.ROICalculator]: {
    'en-US': '8c5879cb-62c4-4e1a-a141-f78ee1842c8a',
    'fr-FR': '8c5879cb-62c4-4e1a-a141-f78ee1842c8a',
  },
  [WidgetConfigPages.DiscoverChatbotType]: {
    'en-US': '95168d08-d5be-4477-a83e-3b59c3013b2a',
    'fr-FR': 'e0d8679b-4ae5-4b51-add8-a771e487a551',
  },
  [WidgetConfigPages.DiscoverHumanCloneLink]: {
    'en-US': '4000db02-a61f-4f94-8eea-000a6ab1500f',
    'fr-FR': '4000db02-a61f-4f94-8eea-000a6ab1500f',
  },
  [WidgetConfigPages.RevenueCalculator]: {
    'en-US': '39f4b472-363f-460f-abd4-da651c539268',
    'fr-FR': '39f4b472-363f-460f-abd4-da651c539268',
  },
  [WidgetConfigPages.DiscoverChatbotText]: {
    'en-US': '03508473-1bdc-488d-92f5-58b010ad94c0',
    'fr-FR': '03508473-1bdc-488d-92f5-58b010ad94c0',
  },
  [WidgetConfigPages.DiscoverChatbotAI]: {
    'en-US': '95ccea92-f543-463f-b58b-dfa304eca4ab',
    'fr-FR': '95ccea92-f543-463f-b58b-dfa304eca4ab',
  },
  [WidgetConfigPages.DiscoverVideobot]: {
    'en-US': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
    'fr-FR': 'e55e08b0-4a75-444f-9117-2b659ff24bbf',
  },
  [WidgetConfigPages.DiscoverCallBot]: {
    'en-US': '1eb59b7d-0627-459e-843a-6adfbb03d5eb',
    'fr-FR': '1eb59b7d-0627-459e-843a-6adfbb03d5eb',
  },
};

const getWidgetCode = (page: WidgetConfigPages, locale: string) => {
  return configs[page][locale];
};

const widgetConfig = {
  getWidgetCode,
};

export default widgetConfig;
